<template>
  <v-layout wrap row dark ma-2 class="background-time">
    <v-flex lg2 md2 v-on:click="clickQTime" style="position: relative; top:-3px;">
      <v-flex class="tine_header">Quick Time</v-flex>
      <v-select
        :items="options"
        v-model="startTime"
        @change="setEndTime"
        solo
        dark
      >
        <template v-slot:prepend-inner>
          <v-icon class="time-box">access_time</v-icon>
        </template>
      </v-select>
    </v-flex>
    <v-flex offset-md1 offset-lg1 lg6 md6>
      <v-flex class="tine_header">Date Picker</v-flex>
      <v-flex row ml-0>
        <v-flex lg5 md5>
          <VueCtkDateTimePicker
            id="#DateTimePicker1"
            v-model="abStartTime"
            color="#1B4A86"
            label="Start Time"
            format="YYYY-MM-DDTHH:mm:ss"
            dark/>
        </v-flex>
        <v-flex lg1 md1 mt-2>
          <p style="color: #cccccc;">To</p>
        </v-flex>
        <v-flex lg5 md5>
          <VueCtkDateTimePicker
            id="#DateTimePicker2"
            v-model="abEndTime"
            color="#1B4A86"
            label="End Time"
            format="YYYY-MM-DDTHH:mm:ss"
            dark/>
        </v-flex>
        <v-flex md1 lg1 ml-0 style="position: relative; text-align: right; left: 10px;">
          <button
            style="height: 42px;"
            class="btn bg-success font-weight-bold text-white"
            type="submit"
            @click="absoluteTime">
              Submit
          </button>
        </v-flex>
      </v-flex>
    </v-flex>
    <v-flex lg2 md2 px-0 offset-md1 offset-lg1 v-on:click="clickReTime" style="position: relative; top:-3px;">
      <v-flex class="tine_header">Auto Refresh</v-flex>
      <v-select
        :items="refreshTime"
        v-model="refreshTimeStart"
        @change="setRefreshTime"
        solo
        dark
      >
        <template v-slot:prepend-inner>
          <v-icon class="time-box">access_alarm</v-icon>
        </template>
      </v-select>
    </v-flex>
  </v-layout>

</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import jwtDecode from 'jwt-decode'

export default {
  name: 'topSearchBar',
  props: {
    textTemp: {
      type: String
    },
    selectedIndex: {
      type: String
    },
    setsearch: {
      type: Object
    },
    clearField: {
      type: Boolean
    }
  },
  components: {
    VueCtkDateTimePicker
  },
  data () {
    return {
      datePickerOpt: {
        format: 'YYY-MM-DD hh:mm a',
        useCurrent: false,
        showClear: true,
        showClose: true
      },
      startTime: 'now-15m',
      endTime: 'now',
      refreshTimeStart: 0,
      refreshTime: [
        {
          text: 'Off',
          value: 0
        },
        {
          text: '30 Second',
          value: 30000
        },
        {
          text: '1 Minute',
          value: 60000
        },
        {
          text: '3 Minute',
          value: 180000
        },
        {
          text: '5 Minute',
          value: 300000
        },
        {
          text: '10 Minute',
          value: 600000
        },
        {
          text: '15 Minute',
          value: 900000
        },
        {
          text: '30 Minute',
          value: 1800000
        },
        {
          text: '1 Hour',
          value: 3600000
        }
      ],
      interval: '30m',
      abStartTime: '',
      newDashboardType: null,
      abEndTime: '',
      setAlert: false,
      options: [
        {
          text: 'Last 15 minutes',
          value: 'now-15m'
        },
        {
          text: 'Last 30 minutes',
          value: 'now-30m'
        },
        {
          text: 'Last 1 hour',
          value: 'now-1h'
        },
        {
          text: 'Last 12 hours',
          value: 'now-12h'
        },
        {
          text: 'Last 24 hours',
          value: 'now-1d'
        },
        {
          text: 'Last 7 days',
          value: 'now-7d'
        },
        {
          text: 'Last 30 days',
          value: 'now-1M'
        }
      ],
      duration: '',
      ampid: ''
    }
  },
  created () {
    this.token = sessionStorage.getItem('user-token')
    this.decoded = jwtDecode(this.token)
    this.ampid = this.decoded.ampid
    this.user_id = this.decoded._id
    if (this.setsearch) {
      this.abStartTime = this.setsearch.startdate
      this.abEndTime = this.setsearch.enddate
      // this.abStartTime = '2021-06-29T09:00:00'
      // this.abEndTime = '2021-06-29T10:03:00'
      setTimeout(() => {
        this.absoluteTime()
      }, 500)
    }
  },
  methods: {
    absoluteTime () {
      if (this.abStartTime !== '' && this.abEndTime !== '') {
        this.startTime = Date.parse(this.abStartTime)
        this.endTime = Date.parse(this.abEndTime)
        this.duration = this.endTime - this.startTime
        // Time Range
        if (this.duration <= (15 * 60 * 60)) {
          this.interval = '10s'
        } else if (this.duration <= (30 * 60 * 60) && this.duration > (15 * 60 * 60)) {
          this.interval = '30s'
        } else if (this.duration <= (60 * 60 * 60) && this.duration > (30 * 60 * 60)) {
          this.interval = '1m'
        } else if (this.duration <= (12 * 60 * 60 * 60) && this.duration > (60 * 60 * 60)) {
          this.interval = '30m'
        } else if (this.duration <= (24 * 60 * 60 * 60) && this.duration > (12 * 60 * 60 * 60)) {
          this.interval = '30m'
        } else if (this.duration <= (7 * 24 * 60 * 60 * 60) && this.duration > (24 * 60 * 60 * 60)) {
          this.interval = '3h'
        } else if (this.duration > (7 * 24 * 60 * 60 * 60)) {
          this.interval = '12h'
        }
      }
      window.analytics.track('[Datetime][Data Picker][Submit]', {
        value: {
          start: this.abStartTime,
          end: this.abEndTime,
          interval: this.interval
        }
      }, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
      this.$emit('setTime', this.startTime, this.endTime, this.interval)
    },
    setEndTime (startTime) {
      window.analytics.track('[Datetime][Quick Time][Last]', {
        value: startTime
      }, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
      this.startTime = startTime
      if (this.startTime === 'now-15m') {
        this.interval = '10s'
        this.endTime = 'now'
        this.abStartTime = ''
        this.abEndTime = ''
      } else if (this.startTime === 'now-30m') {
        this.interval = '30s'
        this.endTime = 'now'
        this.abStartTime = ''
        this.abEndTime = ''
      } else if (this.startTime === 'now-1h') {
        this.interval = '1m'
        this.endTime = 'now'
        this.abStartTime = ''
        this.abEndTime = ''
      } else if (this.startTime === 'now-12h') {
        this.interval = '10m'
        this.endTime = 'now'
        this.abStartTime = ''
        this.abEndTime = ''
      } else if (this.startTime === 'now-1d') {
        this.interval = '30m'
        this.endTime = 'now'
        this.abStartTime = ''
        this.abEndTime = ''
      } else if (this.startTime === 'now-7d') {
        this.interval = '3h'
        this.endTime = 'now'
        this.abStartTime = ''
        this.abEndTime = ''
      } else if (this.startTime === 'now-1M') {
        this.interval = '12h'
        this.endTime = 'now'
        this.abStartTime = ''
        this.abEndTime = ''
      } else {
        this.endTime = this.endTime
      }
      this.$emit('setTime', this.startTime, this.endTime, this.interval)
    },
    setRefreshTime (refreshTimeStart) {
      window.analytics.track('[Datetime][Auto Refresh][RefreshTime]', {
        value: refreshTimeStart
      }, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
      this.$emit('setRefreshTime', refreshTimeStart)
    },
    clickQTime () {
      window.analytics.track('[Datetime][Quick Time]', {}, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
    },
    clickReTime () {
      window.analytics.track('[Datetime][Auto Refresh]', {}, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
    }
  },
  watch: {
    textTemp: {
      handler: function (textTemp) {
        this.textTemp = this.textTemp
      }
    },
    abStartTime: function () {
      window.analytics.track('[Datetime][Data Picker][Start Time]', {}, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
    },
    abEndTime: function () {
      window.analytics.track('[Datetime][Data Picker][End Time]', {}, {
        integrations: {
            Amplitude: {
              'session_id': this.ampid
            }
          }
        }
      )
    },
    clearField: function () {
      if (this.clearField) {
        this.abStartTime = ''
        this.abEndTime = ''
        this.startTime = 'now-15m'
        this.endTime = 'now'
        this.absoluteTime()
        this.clearField = false
      }
    }
  }
}
</script>

<style scoped>
.tine_header {
  text-align: left;
  color: #cccccc;
}
.time-box {
  border-right: 1px solid;
  padding-right: 5px;
}
.background-time {
  border: 1px solid #244365;
  padding-top: 20px;
  border-radius: 5px;
  padding-left: 20px;
  padding-right: 20px;
  background-color: #1D2126;
}
.datepicker_to {
  border-top: 1px solid #cccccc;
  border-bottom: 1px solid #cccccc;
  background-color: #424242;
}
.v-select-select {
  border-color: lawngreen;
}
.v-select-select option {
  border-color: lawngreen;
  padding: 4px;
  line-height: 24px;
  height: 24px;
  font-family: Tahoma;
  font-size: 12px;
  color: #003399;
}
</style>



// WEBPACK FOOTER //
// src/components/topSearchBar.vue